/* eslint-disable max-len */
import { FC, useEffect, useRef, useState } from 'react';
import { SnakeMachinesContainer, SnakeRow } from './SnakeContainer.styles';
import { SnakeContainerProps } from './SnakeContainer.types';
import { SnakeItem } from './SnakeItem';

export const SnakeContainer: FC<SnakeContainerProps> = ({
  machineData,
  configVarLabel,
  statesFilter,
  onItemClick,
  isStationActive,
  isMobile,
  onUpdateVariableDisplay,
  loadingUpdateVariableDisplay,
  showVariableConfig,
}) => {
  const [elementsPerRow, setElementsPerRow] = useState(5);
  const snakeContainerRef = useRef<HTMLDivElement | null>(null);

  const rearrangeObjects = (objects: any) => {
    const rearrangedObjects = [];
    let row = [];
    let ascending = true;

    for (let i = 0; i < objects.length; i++) {
      row.push(objects[i]);

      // Si alcanzamos el final de la fila, agregamos la fila a rearrangedObjects y limpiamos la fila para la próxima iteración
      if (row.length === elementsPerRow || i === objects.length - 1) {
        const empty = {};
        for (let index = 0; row.length - elementsPerRow; index++) {
          row.push(empty);
        }

        rearrangedObjects.push(ascending ? row : row.reverse());
        row = [];
        ascending = !ascending;
      }
    }

    return rearrangedObjects;
  };

  const arrangedObjects = rearrangeObjects(machineData);

  useEffect(() => {
    const calculateElementsPerRow = () => {
      if (snakeContainerRef.current) {
        const desktopXxlScreen = snakeContainerRef.current.clientWidth >= 1802;
        const desktopXlScreen =
          snakeContainerRef.current.clientWidth >= 1540 &&
          snakeContainerRef.current.clientWidth < 1802;
        const containerWidth = snakeContainerRef.current.clientWidth;
        let elementWidth = 240;

        if (desktopXlScreen) elementWidth = 250;
        if (desktopXxlScreen) elementWidth = 280;

        const newElementsPerRow = Math.floor(containerWidth / elementWidth);

        setElementsPerRow(newElementsPerRow);
      }
    };

    calculateElementsPerRow();
    window.addEventListener('resize', calculateElementsPerRow);

    return () => window.removeEventListener('resize', calculateElementsPerRow);
  }, [machineData, snakeContainerRef.current?.clientWidth]);

  return (
    <SnakeMachinesContainer className="snake-container" ref={snakeContainerRef} isMobile={isMobile}>
      {arrangedObjects.map((row, rowIndex) => (
        <SnakeRow key={rowIndex} className="snake-row">
          {row.map((item, itemIndex) => (
            <SnakeItem
              key={`${rowIndex}${itemIndex}`}
              arrangedObjects={arrangedObjects}
              item={item}
              itemIndex={itemIndex}
              row={row}
              rowIndex={rowIndex}
              statesFilter={statesFilter}
              onItemClick={onItemClick}
              isStationActive={isStationActive}
              isMobile={isMobile}
              onUpdateVariableDisplay={onUpdateVariableDisplay}
              loadingUpdateVariableDisplay={loadingUpdateVariableDisplay}
              configVarLabel={configVarLabel}
              showVariableConfig={showVariableConfig}
            />
          ))}
        </SnakeRow>
      ))}
    </SnakeMachinesContainer>
  );
};
